import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

import { TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";
import { AddressMaxLength } from "@/validations/address";

import { CompanyFormType } from "../../../../formType";

type AddressFormProps = {
    index: number;
};

const AddressForm: FC<AddressFormProps> = ({ index }) => {
    const { t } = useTranslation();

    const { control } = useFormContext<CompanyFormType>();

    return (
        <Grid container marginTop={1} marginBottom={2}>
            <Grid item sm={7} xs={12}>
                <TextInput
                    name={`addresses.${index}.street`}
                    control={control}
                    label={t("Common.Street")}
                    required
                    maxLength={AddressMaxLength.Street}
                />
            </Grid>
            <Grid item sm={2.5} xs={6}>
                <TextInput
                    name={`addresses.${index}.houseNumber`}
                    control={control}
                    label={t("Common.Number")}
                    required
                    maxLength={AddressMaxLength.HouseNumber}
                />
            </Grid>
            <Grid item sm={2.5} xs={6}>
                <TextInput
                    name={`addresses.${index}.boxNumber`}
                    control={control}
                    label={t("Common.Box")}
                    maxLength={AddressMaxLength.BoxNumber}
                />
            </Grid>
            <Grid item sm={4} xs={12}>
                <TextInput
                    name={`addresses.${index}.zipCode`}
                    control={control}
                    maxLength={AddressMaxLength.ZipCode}
                    label={t("Common.PostalCode")}
                    required
                />
            </Grid>
            <Grid item sm={8} xs={12}>
                <TextInput
                    name={`addresses.${index}.city`}
                    control={control}
                    label={t("Common.City")}
                    required
                    maxLength={AddressMaxLength.City}
                />
            </Grid>
            <Grid item sm={4} xs={12}>
                <RefSelectInput name={`addresses.${index}.country.id`} required table="country" control={control} />
            </Grid>
        </Grid>
    );
};

export default AddressForm;
